import React from "react";
import CheckoutFlow from "../components/checkout/CheckoutFlow";

export default function Checkout(props) {
  return <CheckoutFlow {...props} />;
}